import React from 'react';
import PropTypes from 'prop-types';
import { getRandomWidth } from '../helpers/get-random-width';

const SkeletonLines = ({ lines = 1 }) => {
  if (lines > 0) {
    return new Array(lines).fill(<div />).map((_, index) => (
      <span className="ws-ui-text-skeleton__line-container" key={`item-${index + Math.random()}`}>
        &nbsp;
        <span
          className="ws-ui-text-skeleton__line"
          style={{
            maxWidth: lines !== 1 && getRandomWidth(),
          }}
        />
      </span>
    ));
  }
  return null;
};

SkeletonLines.propTypes = {
  lines: PropTypes.number,
};

export default SkeletonLines;
